import * as api from '../../api/api-ingreso-recobro';
import { 
    GET_CONFIG_FORM35,
    GET_INGRESO_GRILLA
  
    
} from '../types';

export const configuracionFormAction35 = (query) => ({
    type: GET_CONFIG_FORM35,
    payload: api.getConfiguracionForm35(query)
});
export const obtenerIngresoGrilla = (query) => ({
    type: GET_INGRESO_GRILLA,
    payload: api.getIngresoGrilla(query)
});
